import { Injectable, signal } from '@angular/core';

export type CookieConsent = 'accepted' | 'rejected';
const KEY = 'crescio-cookie-consent';

@Injectable({ providedIn: 'root' })
export class CookieService {
  readonly consent = signal<CookieConsent | null>(
    (localStorage.getItem(KEY) as CookieConsent) ?? null,
  );

  accept(): void {
    localStorage.setItem(KEY, 'accepted');
    this.consent.set('accepted');
  }

  reject(): void {
    localStorage.setItem(KEY, 'rejected');
    this.consent.set('rejected');
  }

  isAccepted(): boolean {
    return this.consent() === 'accepted';
  }
}
